export class VacationWeeks {
    constructor(odd = 0, even = 0, total = 0) {
        this.oddWeeks = odd;
        this.evenWeeks = even;
        this.totalWeeks = total;
    }
    public oddWeeks: number;
    public evenWeeks: number;
    public totalWeeks: number;
}
